import React, {Component} from 'react';
import {Avatar, Dialog} from '../widgets';
import './WriteReview.css';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import actions from './reviews.actions';

class WriteReview extends Component {
	constructor() {
		super();

		this.state = {
			hoverStar: null
		};

		this.onStarEnter = [1, 2, 3, 4, 5].reduce(
			(accum, num) => (accum[num] = () => this.setState({hoverStar: num})) && accum,
			{}
		);
		this.onStarLeave = () => this.setState({hoverStar: null});
	}

	render() {
		if (!this.props.review || !this.props.profile) return null;

		const {
			profile: {
				user: {firstname, lastname, location}
			},
			review: {rating, communication, quality, affordability, trust, content},
			onSave,
			onCancel,
			onThumbsUpCommunication,
			onThumbsDownCommunication,
			onClearCommunication,
			onThumbsUpQuality,
			onThumbsDownQuality,
			onClearQuality,
			onThumbsUpAffordability,
			onThumbsDownAffordability,
			onClearAffordability,
			onThumbsUpTrust,
			onThumbsDownTrust,
			onClearTrust,
			onChangeContent,
			onRating1,
			onRating2,
			onRating3,
			onRating4,
			onRating5
		} = this.props;

		const hoverStar = this.state.hoverStar;

		return (
			<Dialog
				className="WriteReview"
				title={`Review ${firstname}'s work`}
				onSave={onSave}
				onCancel={onCancel}
				submitOnEnter={false}>
				<div className="WriteReview-details">
					<Avatar
						className="WriteReview-avatar"
						provider={this.props.profile}
						size={64}
						link={false}
					/>
					<div className="WriteReview-name">
						<h1>
							{firstname} {lastname}
						</h1>
						<div className="WriteReview-geo">
							<span className="icon icon-room" />
							<span className="WriteReview-name">{location && location.suburb}</span>
						</div>
					</div>
				</div>

				<div className="WriteReview-group WriteReview-overall">
					<label>
						<h2>Overall rating</h2>
						<div className="WriteReview-rating WriteReview-stars">
							<span
								className={`icon  ${
									(hoverStar
									? hoverStar >= 1
									: rating >= 1)
										? 'icon-star active'
										: 'icon-star_border'
								}`}
								onMouseEnter={this.onStarEnter[1]}
								onMouseLeave={this.onStarLeave}
								onClick={onRating1}
							/>
							<span
								className={`icon ${
									(hoverStar
									? hoverStar >= 2
									: rating >= 2)
										? 'icon-star active'
										: 'icon-star_border'
								}`}
								onMouseEnter={this.onStarEnter[2]}
								onMouseLeave={this.onStarLeave}
								onClick={onRating2}
							/>
							<span
								className={`icon ${
									(hoverStar
									? hoverStar >= 3
									: rating >= 3)
										? 'icon-star active'
										: 'icon-star_border'
								}`}
								onMouseEnter={this.onStarEnter[3]}
								onMouseLeave={this.onStarLeave}
								onClick={onRating3}
							/>
							<span
								className={`icon ${
									(hoverStar
									? hoverStar >= 4
									: rating >= 4)
										? 'icon-star active'
										: 'icon-star_border'
								}`}
								onMouseEnter={this.onStarEnter[4]}
								onMouseLeave={this.onStarLeave}
								onClick={onRating4}
							/>
							<span
								className={`icon ${
									(hoverStar
									? hoverStar >= 5
									: rating === 5)
										? 'icon-star active'
										: 'icon-star_border'
								}`}
								onMouseEnter={this.onStarEnter[5]}
								onMouseLeave={this.onStarLeave}
								onClick={onRating5}
							/>
						</div>
					</label>
					<p>How would you rate {firstname}'s work overall?</p>
				</div>

				<div className="WriteReview-group WriteReview-text">
					<h2>Your review</h2>
					<textarea
						spellCheck={true}
						className="WriteReview-entry"
						onChange={onChangeContent}
						value={content}
						maxLength={512}
						placeholder={`What was your experience like with ${firstname}'s services?`}
					/>
					<div className="WriteReview-counter">
						{content && content.length ? content.length : 0} / 512 characters
					</div>
				</div>

				<div className="WriteReview-group WriteReview-detailed">
					<h2>Attribute ratings</h2>

					<label>
						<h3>Communication</h3>
						<div className="WriteReview-rating WriteReview-thumbs">
							<span
								onClick={communication !== true ? onThumbsUpCommunication : onClearCommunication}
								className={`icon icon-thumb_up ${communication === true && 'active'}`}
							/>
							<span
								onClick={communication !== false ? onThumbsDownCommunication : onClearCommunication}
								className={`icon icon-thumb_down ${communication === false && 'active'}`}
							/>
						</div>
					</label>
					<p>Does {firstname} communicate effectively and promptly?</p>

					<label>
						<h3>Quality</h3>
						<div className="WriteReview-rating WriteReview-thumbs">
							<span
								onClick={quality !== true ? onThumbsUpQuality : onClearQuality}
								className={`icon icon-thumb_up ${quality === true && 'active'}`}
							/>
							<span
								onClick={quality !== false ? onThumbsDownQuality : onClearQuality}
								className={`icon icon-thumb_down ${quality === false && 'active'}`}
							/>
						</div>
					</label>
					<p>Is {firstname}'s work acceptable quality?</p>

					<label>
						<h3>Affordability</h3>
						<div className="WriteReview-rating WriteReview-thumbs">
							<span
								onClick={affordability !== true ? onThumbsUpAffordability : onClearAffordability}
								className={`icon icon-thumb_up ${affordability === true && 'active'}`}
							/>
							<span
								onClick={affordability !== false ? onThumbsDownAffordability : onClearAffordability}
								className={`icon icon-thumb_down ${affordability === false && 'active'}`}
							/>
						</div>
					</label>
					<p>Does {firstname} offer value for money?</p>

					<label>
						<h3>Trust</h3>
						<div className="WriteReview-rating WriteReview-thumbs">
							<span
								onClick={trust !== true ? onThumbsUpTrust : onClearTrust}
								className={`icon icon-thumb_up ${trust === true && 'active'}`}
							/>
							<span
								onClick={trust !== false ? onThumbsDownTrust : onClearTrust}
								className={`icon icon-thumb_down ${trust === false && 'active'}`}
							/>
						</div>
					</label>
					<p>Does {firstname} follow through on his promises?</p>
				</div>
			</Dialog>
		);
	}
}

const ConnectedWriteReview = connect(
	({profile, reviews, session}) => ({
		profile,
		review: reviews && reviews.editing
	}),
	dispatch => ({
		...[1, 2, 3, 4, 5].reduce(
			(obj, num) =>
				(obj['onRating' + num] = () => dispatch(actions.reviewsNewUpdate({rating: num}))) && obj,
			{}
		),

		onThumbsUpCommunication: () => dispatch(actions.reviewsNewUpdate({communication: true})),
		onThumbsDownCommunication: () => dispatch(actions.reviewsNewUpdate({communication: false})),
		onClearCommunication: () => dispatch(actions.reviewsNewUpdate({communication: null})),

		onThumbsUpQuality: () => dispatch(actions.reviewsNewUpdate({quality: true})),
		onThumbsDownQuality: () => dispatch(actions.reviewsNewUpdate({quality: false})),
		onClearQuality: () => dispatch(actions.reviewsNewUpdate({quality: null})),

		onThumbsUpAffordability: () => dispatch(actions.reviewsNewUpdate({affordability: true})),
		onThumbsDownAffordability: () => dispatch(actions.reviewsNewUpdate({affordability: false})),
		onClearAffordability: () => dispatch(actions.reviewsNewUpdate({affordability: null})),

		onThumbsUpTrust: () => dispatch(actions.reviewsNewUpdate({trust: true})),
		onThumbsDownTrust: () => dispatch(actions.reviewsNewUpdate({trust: false})),
		onClearTrust: () => dispatch(actions.reviewsNewUpdate({trust: null})),

		onChangeContent: e => dispatch(actions.reviewsNewUpdate({content: e.target.value})),

		onSave: () => {
			dispatch(actions.persistReview());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => {
			dispatch(actions.reviewsNewCancelled());
			dispatch(uiActions.uiModal(null));
		}
	})
)(WriteReview);

export default ConnectedWriteReview;



// WEBPACK FOOTER //
// ./src/profile/WriteReview.js